// The chart inputs of an extended open-ended question, ported from the answer-variants chart view
// (Items.ChartView#renderReactChart).
//
// The chart itself is the shared answer-variants one; what is family-specific is which of the
// question's format flags reach it, since `format` is chart-scoped by the time the chart reads it.

import { getColorTheme, getFeatures, getModelValue, resolveTrait } from '@aytm/app/stats/lib/stat-page'
import { isRType as calcIsRType, isTraitType as calcIsTraitType } from '@aytm/app/stats/page/components/lib/utils'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'
import { calcIgnoreAmount, calcIgnorePercents } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

export const calcChartProps = ({
  id,
  questionKey,
  type,
  format,
  answer,
  answerVariants,
  batches,
  aType,
  answerType,
  answerLabels,
  unitLabel,
  plotLines,
  degree,
  scaleTmpl,
  scalePow,
  scaleSteps,
  questionChartMode,
  chartMode,
  zoomLevel,
  sortOrder,
  handlers = {}
} = {}) => {
  const traitName = getModelValue('trait')
  const isTraitType = calcIsTraitType({ format, type })

  return {
    // the block's own question, never a parent it is nested under: the chart wrapper is named after it
    questionId: id,
    questionKey,
    qType: type,
    answer,
    answerVariants,
    batches,
    sortOrder,
    // the model default is the fallback the legacy resolution order ended on
    chartMode: chartMode || questionChartMode,
    globalChartMode: getModelValue('chartMode'),
    zoomLevel,
    globalZoomLevel: getModelValue('zoomLevel'),
    zoomType: false !== format?.zoomType,
    // root-format flags: the chart's own `format` is chart-scoped, so it cannot derive these
    ignoreRefs: true === format?.ignoreRefs,
    ignoreAmount: calcIgnoreAmount(format),
    ignorePercents: calcIgnorePercents(format),
    ignoreTraits: true === format?.ignoreTraits || !isTraitType,
    percentsOnly: true === format?.percentsOnly,
    isRType: calcIsRType({ type }),
    // the counting mode itself, so the chart's shares, intervals and axis follow it
    rType: calcIsRType({ type }) ? getModelValue('rType') : 'cases',
    isTraitType,
    traitName,
    trait: resolveTrait(traitName),
    aType: aType || 'A',
    answerType: answerType || 'amount',
    answerLabels,
    unitLabel,
    plotLines: plotLines || [],
    degree,
    scaleTmpl,
    scalePow,
    scaleSteps,
    colorTheme: getColorTheme(),
    chartLegendMode: getModelValue('chartLegendMode'),
    confidenceLevel: getModelValue('confidenceLevel'),
    significanceLevel: getModelValue('significanceLevel'),
    confidenceLevels: PageGlobals.CONFIDENCE_LEVELS,
    features: getFeatures(),
    onChartModeChange: handlers.onChartModeChange,
    onZoomChange: handlers.onZoomChange,
    onChartReady: handlers.onChartReady
  }
}
